<script setup lang="ts">
import { LocalModelType } from "@/features/BuildingProject";
import ModelCard from "./ModelCard.vue";

const props = defineProps<{
  models: Array<LocalModelType>;
}>();

const emit = defineEmits<{
  toggleModel: [model: LocalModelType];
}>();
</script>

<template>
  <!-- Secondary to Selected models above it; renders nothing rather than an empty heading. -->
  <div
    v-if="props.models.length > 0"
    class="flex flex-col gap-2">
    <span class="t-caption text-type-muted">Also available</span>
    <ul class="flex flex-wrap gap-2">
      <li
        v-for="model in props.models"
        :key="model.name">
        <ModelCard
          :model="model"
          @toggle="emit('toggleModel', $event)" />
      </li>
    </ul>
  </div>
</template>
